import { render, staticRenderFns } from "./FmFormItem.vue?vue&type=template&id=5b5c879d&scoped=true&"
import script from "./FmFormItem.vue?vue&type=script&lang=js&"
export * from "./FmFormItem.vue?vue&type=script&lang=js&"
import style0 from "./FmFormItem.vue?vue&type=style&index=0&id=5b5c879d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5c879d",
  null
  
)

export default component.exports